import { OPERATORS } from './constants';

export const FACT_TYPE_OPTIONS = Array.from(
  new Set([...OPERATORS.flatMap((op) => op.type), 'object']),
).sort();

export const PATH_TYPE_OPTIONS = FACT_TYPE_OPTIONS.filter((type) => type !== 'object');
